import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=104c33ef"
import script from "./OrderListItem.vue?vue&type=script&lang=ts"
export * from "./OrderListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports